export default {"src":"/_next/static/media/icInfo-circle.95e535b9.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};